import { render, staticRenderFns } from "./Post2FBModal.vue?vue&type=template&id=b19b0c82&scoped=true&"
import script from "./Post2FBModal.vue?vue&type=script&lang=js&"
export * from "./Post2FBModal.vue?vue&type=script&lang=js&"
import style0 from "./Post2FBModal.vue?vue&type=style&index=0&id=b19b0c82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19b0c82",
  null
  
)

export default component.exports